<template>
  <div class="cheese-page">
    <section class="cheese-hero">
      <div class="cheese-orbit" aria-hidden="true">
        <span v-for="index in 6" :key="index" :class="'cheese-float cheese-float-' + index">
          <img :src="cheeseIcon" alt="" />
        </span>
      </div>
      <div class="cheese-hero-copy">
        <span class="cheese-kicker">奶酪秘境</span>
        <h1>探索奶酪秘境</h1>
        <p>使用奶酪币开启秘境箱子，收获的饰品会直接进入你的背包。</p>
        <div class="cheese-hero-actions">
          <button type="button" @click="scrollToCases">进入秘境</button>
          <button class="secondary" type="button" @click="rulesVisible = !rulesVisible">玩法说明</button>
        </div>
      </div>
      <div class="cheese-brand" aria-hidden="true">
        <span class="cheese-brand-ring"></span>
        <img :src="heroImage" alt="" />
        <strong>奶酪秘境</strong>
      </div>
      <aside class="cheese-balance">
        <span>我的奶酪币</span>
        <strong><img :src="cheeseIcon" alt="" />{{ formattedCheese }}</strong>
      </aside>
    </section>

    <transition name="cheese-rules">
      <section v-if="rulesVisible" class="cheese-rules">
        <article><b>01</b><div><strong>获得奶酪币</strong><p>通过站内活动和任务获得奶酪币。</p></div></article>
        <article><b>02</b><div><strong>选择秘境箱</strong><p>每个箱子标注单次消耗，连开会按开启数量一起扣除。</p></div></article>
        <article><b>03</b><div><strong>饰品进入背包</strong><p>开奖结果直接进入饰品背包，可按现有流程回收或申请取回。</p></div></article>
      </section>
    </transition>

    <section ref="caseSection" class="cheese-case-section">
      <header>
        <div><span>奶酪秘境</span><h2>秘境箱池</h2></div>
        <p>秘境箱价格均以奶酪币计价</p>
      </header>
      <div v-if="loading" class="cheese-skeleton-grid" aria-label="正在读取秘境箱">
        <span v-for="index in 5" :key="index" class="cheese-skeleton-card"></span>
      </div>
      <div v-else-if="loadError" class="cheese-state cheese-empty">
        <img :src="cheeseIcon" alt="" />
        <strong>秘境箱加载失败</strong>
        <button type="button" @click="loadCases">重新加载</button>
      </div>
      <div v-else-if="!cases.length" class="cheese-state cheese-empty">
        <img :src="cheeseIcon" alt="" />
        <strong>秘境箱正在准备中</strong>
        <span>请稍后再来看看</span>
      </div>
      <div v-else class="cheese-grid">
        <button
          v-for="item in cases"
          :key="item.id"
          class="cheese-card"
          type="button"
          :style="caseCardStyle(item)"
          @click="openCase(item.id)"
        >
          <span class="cheese-open-count">{{ item.openCount }}</span>
          <span v-if="item.hasHiddenGold" class="cheese-hidden-mark" aria-label="包含金色传说">
            <img :src="hiddenGoldImage" alt="" />
          </span>
          <div class="cheese-card-art">
            <span></span>
            <img :src="item.image" :data-fallback="fallbackCase" :alt="item.name" @error="replaceImage" />
          </div>
          <strong>{{ item.name }}</strong>
          <em>{{ item.group }}</em>
          <b>{{ formatPrice(item.price) }}<img :src="cheeseIcon" alt="奶酪币" /></b>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Cheese",
  data() {
    return {
      loading: true,
      loadError: false,
      rulesVisible: false,
      cases: [],
      cheeseIcon: require("../assets/pizzaking/cheese-token.svg"),
      heroImage: require("../assets/pizzaking/cheese-realm-hero.png"),
      hiddenGoldImage: require("../assets/pizzaking/hidden-gold.png"),
      fallbackCase: require("../assets/hotpizza/hp-case-orange.png"),
    };
  },
  computed: {
    formattedCheese() {
      return Number(this.$store.state.cheese || 0).toFixed(2);
    },
  },
  mounted() {
    this.loadCases();
  },
  methods: {
    normalizeAssetUrl(url) {
      return String(url || "")
        .replace("http://csgoapi.akaifa998.icu/http://", "http://")
        .replace("http://csgoapi.akaifa998.icu/https://", "https://");
    },
    loadCases() {
      this.loading = true;
      this.loadError = false;
      this.$axios.post("/index/Box/boxList", this.$qs.stringify({})).then((res) => {
        const groups = res.data && res.data.status == 1 && res.data.data ? res.data.data.list || [] : [];
        this.cases = groups.reduce((list, group) => list.concat((group.box_list || [])
          .filter((box) => box.consume_currency === "cheese")
          .map((box) => ({
            id: box.id,
            name: box.name,
            group: group.type_name,
            price: box.price,
            openCount: Number(box.open_count || 0),
            image: this.normalizeAssetUrl(box.img_main || box.img_active) || this.fallbackCase,
            backgroundImage: this.normalizeAssetUrl(box.cheese_background),
            hasHiddenGold: Number(box.has_hidden_gold || 0) === 1,
          }))), []);
        this.loading = false;
      }).catch(() => {
        this.cases = [];
        this.loadError = true;
        this.loading = false;
      });
    },
    caseCardStyle(item) {
      if (!item.backgroundImage) return {};
      return {
        backgroundImage: `linear-gradient(180deg, rgba(22, 24, 33, .22), rgba(22, 24, 33, .94)), url(${JSON.stringify(item.backgroundImage)})`,
      };
    },
    formatPrice(value) {
      return Number(value || 0).toFixed(2).replace(/\.00$/, "");
    },
    replaceImage(event) {
      event.target.src = event.target.dataset.fallback;
    },
    scrollToCases() {
      this.$refs.caseSection.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    openCase(boxId) {
      this.$router.push({ path: "/Openbox", query: { box_id: boxId, from: "cheese" } });
    },
  },
};
</script>

<style lang="less" scoped>
.cheese-page {
  min-height: calc(100vh - 195px);
  width: 100%;
  min-width: 0;
  padding: 215px 20px 90px 270px;
  overflow-x: hidden;
  color: #f7f3e9;
  background: linear-gradient(180deg, #1d202c 0, #171923 100%);
  box-sizing: border-box;
}

.cheese-hero {
  width: 100%;
  max-width: 1580px;
  min-height: 390px;
  margin: 0 auto;
  padding: clamp(30px, 4vw, 62px);
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(280px, .72fr);
  align-items: center;
  gap: clamp(20px, 3vw, 48px);
  background:
    radial-gradient(circle at 68% 44%, rgba(255, 207, 75, 0.22), transparent 28%),
    linear-gradient(118deg, #242530 0%, #403421 58%, #1e222c 100%);
  border: 1px solid rgba(255, 204, 84, 0.26);
  border-radius: 22px;
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.28);
  box-sizing: border-box;
}

.cheese-hero::after {
  content: "";
  width: 54%;
  height: 58%;
  position: absolute;
  right: -8%;
  bottom: -32%;
  background: rgba(255, 190, 45, 0.08);
  border-radius: 50%;
  transform: rotate(-8deg);
}

.cheese-hero-copy { min-width: 0; position: relative; z-index: 3; max-width: 650px; }
.cheese-kicker { color: #ffbd35; font-size: 13px; font-weight: 900; letter-spacing: .18em; }
.cheese-hero h1 { margin: 12px 0 18px; color: #ffbd35; font-size: clamp(44px, 5.2vw, 78px); line-height: .98; letter-spacing: -.055em; text-shadow: 0 10px 30px rgba(190, 116, 4, .25); }
.cheese-hero p { max-width: 640px; margin: 0; color: #c8c4bb; font-size: 17px; line-height: 1.9; }
.cheese-hero-actions { margin-top: 28px; display: flex; gap: 12px; }
.cheese-hero-actions button { min-width: 146px; min-height: 48px; padding: 0 22px; color: #211902; background: #ffc13a; border: 1px solid #ffd878; border-radius: 8px; font-size: 15px; font-weight: 900; cursor: pointer; }
.cheese-hero-actions button.secondary { color: #f4cf76; background: rgba(52, 45, 33, .72); border-color: rgba(255, 199, 70, .38); }

.cheese-brand { width: clamp(270px, 29vw, 390px); aspect-ratio: 1; position: relative; z-index: 2; justify-self: center; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.cheese-brand::before { content: ""; position: absolute; inset: 18%; background: radial-gradient(circle, rgba(255, 197, 53, .24), transparent 68%); filter: blur(14px); }
.cheese-brand-ring { position: absolute; inset: 7%; border: 1px solid rgba(255, 205, 85, .32); border-radius: 50%; box-shadow: inset 0 0 60px rgba(255, 196, 58, .08), 0 0 70px rgba(255, 181, 34, .08); }
.cheese-brand img { width: 94%; height: 94%; position: relative; object-fit: contain; filter: drop-shadow(0 24px 30px rgba(0, 0, 0, .34)); }
.cheese-brand strong { margin-top: -42px; position: relative; color: #ffe6a7; font-size: 25px; line-height: 1; letter-spacing: .12em; text-shadow: 0 2px 16px rgba(255, 183, 36, .34); }

.cheese-balance { min-width: 170px; padding: 12px 16px; position: absolute; z-index: 4; top: 24px; right: 24px; color: #c9c3b4; background: rgba(16, 18, 25, .7); border: 1px solid rgba(255, 207, 83, .2); border-radius: 10px; backdrop-filter: blur(8px); }
.cheese-balance span { display: block; font-size: 12px; }
.cheese-balance strong { margin-top: 6px; display: flex; align-items: center; gap: 7px; color: #ffd45e; font-size: 22px; }
.cheese-balance img { width: 22px; height: 22px; }

.cheese-orbit { position: absolute; inset: 0; pointer-events: none; }
.cheese-float { width: 42px; height: 42px; position: absolute; opacity: .42; }
.cheese-float img { width: 100%; height: 100%; }
.cheese-float-1 { left: 4%; top: 9%; }
.cheese-float-2 { left: 45%; top: 12%; width: 30px; height: 30px; }
.cheese-float-3 { right: 5%; top: 18%; width: 66px; height: 66px; }
.cheese-float-4 { left: 39%; bottom: 10%; width: 28px; height: 28px; }
.cheese-float-5 { right: 38%; bottom: 8%; }
.cheese-float-6 { left: 7%; bottom: 7%; width: 58px; height: 58px; }

.cheese-rules { width: 100%; max-width: 1580px; margin: 18px auto 0; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.cheese-rules article { min-height: 110px; padding: 20px; display: flex; gap: 16px; background: #242733; border: 1px solid #343848; border-radius: 12px; }
.cheese-rules b { color: #ffc13b; font-size: 28px; }
.cheese-rules strong { font-size: 15px; }
.cheese-rules p { margin: 8px 0 0; color: #8f97aa; font-size: 13px; line-height: 1.65; }
.cheese-rules-enter-active, .cheese-rules-leave-active { transition: opacity .2s ease, transform .2s ease; }
.cheese-rules-enter, .cheese-rules-leave-to { opacity: 0; transform: translateY(-8px); }

.cheese-case-section { width: 100%; max-width: 1580px; margin: 34px auto 0; scroll-margin-top: 215px; }
.cheese-case-section > header { margin-bottom: 18px; display: flex; align-items: flex-end; justify-content: space-between; }
.cheese-case-section header span { color: #ffc13b; font-size: 12px; font-weight: 900; letter-spacing: .16em; }
.cheese-case-section h2 { margin: 5px 0 0; font-size: 28px; }
.cheese-case-section header p { margin: 0; color: #858da1; font-size: 13px; }
.cheese-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(225px, 1fr)); gap: 14px; }
.cheese-card { min-width: 0; min-height: 278px; padding: 14px 12px 18px; position: relative; overflow: hidden; color: #f8f4ea; background-color: #20232f; background-position: center; background-size: cover; border: 1px solid #303441; border-radius: 9px; cursor: pointer; text-align: center; transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease; }
.cheese-card:hover { z-index: 2; border-color: rgba(255, 193, 59, .62); box-shadow: 0 16px 34px rgba(0, 0, 0, .26); transform: translateY(-3px); }
.cheese-card::before { content: ""; position: absolute; inset: 0; background: linear-gradient(180deg, transparent 46%, rgba(20, 22, 31, .82) 100%); pointer-events: none; }
.cheese-card > * { position: relative; z-index: 1; }
.cheese-open-count { position: absolute; top: 14px; left: 14px; color: #8e96a9; font-size: 11px; }
.cheese-card-art { height: 154px; position: relative; display: grid; place-items: center; }
.cheese-card-art span { width: 126px; height: 126px; position: absolute; background: rgba(255, 195, 48, .13); border: 1px solid rgba(255, 211, 99, .2); border-radius: 50%; }
.cheese-card-art > img { width: 94%; max-height: 150px; position: relative; object-fit: contain; filter: drop-shadow(0 18px 20px rgba(0, 0, 0, .34)); transition: transform .22s ease; }
.cheese-card:hover .cheese-card-art > img { transform: translateY(-5px) scale(1.025); }
.cheese-card > strong { display: block; overflow: hidden; font-size: 15px; text-overflow: ellipsis; white-space: nowrap; }
.cheese-card > em { margin-top: 7px; display: block; color: #858da1; font-size: 12px; font-style: normal; }
.cheese-card > b { margin-top: 14px; display: inline-flex; align-items: center; gap: 5px; color: #ffc13b; font-size: 17px; }
.cheese-card > b img { width: 18px; height: 18px; }
.cheese-hidden-mark { width: 46px; height: 46px; padding: 0; position: absolute; z-index: 3; top: 8px; right: 8px; display: grid; place-items: center; background: transparent; border: 0; box-shadow: none; pointer-events: none; }
.cheese-hidden-mark img { width: 44px; height: 44px; object-fit: contain; filter: drop-shadow(0 5px 10px rgba(0, 0, 0, .38)); }
.cheese-state { min-height: 260px; display: grid; place-items: center; color: #9ba2b3; background: #20232f; border: 1px solid #303441; border-radius: 14px; }
.cheese-empty { align-content: center; gap: 8px; }
.cheese-empty img { width: 58px; height: 58px; opacity: .75; }
.cheese-empty strong { color: #f2ddaa; }
.cheese-empty span { font-size: 13px; }
.cheese-empty button { min-height: 38px; padding: 0 20px; color: #211902; background: #ffc13a; border: 0; border-radius: 7px; font-weight: 900; cursor: pointer; }
.cheese-skeleton-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(225px, 1fr)); gap: 14px; }
.cheese-skeleton-card { min-height: 278px; border: 1px solid #303441; border-radius: 9px; background: linear-gradient(100deg, #20232f 20%, #292d39 42%, #20232f 64%); background-size: 300% 100%; animation: cheeseSkeleton 1.4s ease infinite; }

@media (prefers-reduced-motion: no-preference) {
  .cheese-brand img { animation: cheeseBrandFloat 4s ease-in-out infinite; }
  .cheese-float { animation: cheeseFloat 5s ease-in-out infinite; }
  .cheese-float-2, .cheese-float-5 { animation-delay: -1.7s; }
  .cheese-float-3, .cheese-float-6 { animation-delay: -3.2s; }
}
@keyframes cheeseBrandFloat { 50% { transform: translateY(-8px) rotate(1.5deg); } }
@keyframes cheeseFloat { 50% { transform: translateY(-12px) rotate(8deg); opacity: .7; } }
@keyframes cheeseSkeleton { to { background-position: -150% 0; } }

@media (max-width: 980px) {
  .cheese-page { padding-left: 20px; }
  .cheese-hero { grid-template-columns: minmax(0, 1fr) minmax(240px, .7fr); }
  .cheese-hero h1 { font-size: clamp(42px, 7vw, 64px); }
}
@media (max-width: 760px) {
  .cheese-page { padding: 215px 12px 100px; }
  .cheese-hero { min-height: auto; padding: 74px 20px 28px; grid-template-columns: minmax(0, 1fr); gap: 16px; border-radius: 14px; }
  .cheese-hero h1 { max-width: 330px; font-size: clamp(42px, 13vw, 56px); }
  .cheese-hero p { font-size: 14px; line-height: 1.75; }
  .cheese-hero-actions button { min-width: 0; flex: 1; min-height: 46px; padding: 0 12px; }
  .cheese-brand { width: 82vw; max-width: 290px; }
  .cheese-brand strong { margin-top: -34px; font-size: 21px; }
  .cheese-balance { top: 14px; right: 14px; min-width: 142px; }
  .cheese-rules { grid-template-columns: 1fr; }
  .cheese-case-section > header { align-items: flex-start; flex-direction: column; gap: 7px; }
  .cheese-grid, .cheese-skeleton-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
  .cheese-card { min-height: 242px; padding: 12px 8px 14px; }
  .cheese-card-art { height: 142px; }
  .cheese-card-art > img { max-height: 138px; }
  .cheese-card > strong { font-size: 13px; }
  .cheese-hidden-mark { width: 38px; height: 38px; top: 6px; right: 6px; }
  .cheese-hidden-mark img { width: 36px; height: 36px; }
  .cheese-skeleton-card { min-height: 242px; }
}

@media (max-width: 390px) {
  .cheese-hero-actions { flex-direction: column; }
}

@media (max-width: 600px) {
  .cheese-page { padding: 12px 12px 100px; }
}
</style>
